import PreviewBlock from './PreviewBlock';

export { PreviewBlock as DestinationPreviewBlock };
